/* Newsletter nudge: slides in after 9s or 45% scroll; dismissal remembered 30 days; signed up = never again.
   Remembering that needs browser storage, so the nudge only auto-shows once the visitor has allowed "preferences"
   in Shopify's cookie banner (or isn't in a region where the banner applies). No consent = no nudge, no storage.
   Also wires the footer "Cookie preferences" button to reopen Shopify's banner. */
(() => {
  const KEY = 'aac-nudge-off';
  const cp = () => window.Shopify && window.Shopify.customerPrivacy;
  const prefsOK = () => { const c = cp(); return !!(c && c.preferencesProcessingAllowed && c.preferencesProcessingAllowed()); };
  const withPrivacy = (cb) => {   // Customer Privacy API is loaded on demand
    if (cp()) return cb();
    if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err) cb(); });
  };

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-aac-cookie-prefs]')) return;
    if (window.privacyBanner && privacyBanner.showPreferences) privacyBanner.showPreferences();
    else location.href = '/pages/cookie-policy';
  });

  const n = document.querySelector('[data-aac-nudge]');
  if (!n) return;
  const store = (until) => { if (prefsOK()) try { localStorage.setItem(KEY, String(until)); } catch (e) {} };
  const show = () => { n.hidden = false; requestAnimationFrame(() => requestAnimationFrame(() => n.classList.add('is-in'))); };
  let armed = false;
  const arm = () => {
    if (armed || !prefsOK()) return; armed = true;
    let off = 0; try { off = +localStorage.getItem(KEY) || 0; } catch (e) {}
    if (off >= Date.now()) return;
    let shown = false;
    const once = () => { if (!shown) { shown = true; show(); } };
    setTimeout(once, 9000);
    addEventListener('scroll', () => {
      const h = document.documentElement, y = h.scrollTop || document.body.scrollTop;
      if (y / Math.max(1, h.scrollHeight - innerHeight) > 0.45) once();
    }, { passive: true, capture: true });
  };

  if (n.querySelector('[data-aac-nudge-ok]')) { show(); withPrivacy(() => store(Date.now() + 3650 * 864e5)); }
  else { withPrivacy(arm); document.addEventListener('visitorConsentCollected', arm); }

  n.querySelector('[data-aac-nudge-x]').addEventListener('click', () => {
    n.classList.remove('is-in'); setTimeout(() => { n.hidden = true; }, 450);
    store(Date.now() + 30 * 864e5);
  });
})();
